import { render, staticRenderFns } from "./ChannelMember.vue?vue&type=template&id=37d849c0"
import script from "./ChannelMember.vue?vue&type=script&lang=js"
export * from "./ChannelMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports